module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Tools/Spatula-f997e8b3e78f21ce34b271f5deda9d9496301bd97fc6d08699250508aa89adfa.svg";